<root-tag>
  <loading di-register-name="loader"></loading>
  <router base={base}>
    <route path="(\?.*)?"><div is="first"></div></route>
    <route path="/confirm-code(\?.*)?"><div is="confirm-code"></div></route>
    <route path="/input-information(\?.*)?"><div is="input-information"></div></route>
    <route path="/confirm-information(\?.*)?"><div is="confirm-information"></div></route>
    <route path="/oauth(.*)"><div is="oauth"></div></route>
    <route path="/callback/(.*)"><div is="callback-error"></div></route>
  </router>

  <script>

    import first from './contents/first.riot'
    import confirmCode from './contents/confirm-code.riot'
    import inputInformation from './contents/input-information.riot'
    import confirmInformation from './contents/confirm-information.riot'
    import oauth from './contents/oauth.riot'
    import callbackError from './contents/callback-error.riot'

    const loc = window.location;
    const base = `${loc.protocol}//${loc.host}/register`;

    export default {
      base: base,
      components: {
        'first'              : first,
        'confirm-code'       : confirmCode,
        'input-information'  : inputInformation,
        'confirm-information': confirmInformation,
        'oauth'              : oauth,
        'callback-error'     : callbackError,
      }
    }
  </script>
  <style>
    :host {
      height: 100%;
      width: 100%;
    }
  </style>
</root-tag>